import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'embryo-NewProductsCard',
  templateUrl: './NewProductsCard.component.html',
  styleUrls: ['./NewProductsCard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewProductsCardComponent implements OnInit {

   @Input() product : any;

   @Input() currency : string;
   @Input() exchangeMX:number

   @Output() addToCart: EventEmitter<any> = new EventEmitter();

   constructor() { }

   ngOnInit() {
   }

   public addToCartProduct(value:any) {
      this.addToCart.emit(value);
   }


}
